import AlertRegister from './AlertRegister'

export default AlertRegister